// * Import required libraies
import React, {
  useContext,
  useEffect,
  useReducer,
  useRef,
  useState,
} from "react";
import { useHistory } from "react-router-dom";

// * Import 3rd party lib comp
import {
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  Paper,
  TableContainer,
} from "@mui/material";
import { Box, makeStyles } from "@material-ui/core";
import { connect } from "react-redux";

// * Import Actions
import { initialActiveWorkspace } from "../../../redux/stateData";
import {
  updateUserScreen,
  updateStandaloneWsForm,
  updateDialogInfo,
  replaceAlertForm,
  updateAlertForm,
} from "../../../redux/actions";
import { masterTrackGaEvent } from "../../../services/ga";

// * Import Utils
import {
  wrapperUpdateWorksheetStatus,
  initialWsFormScreenValue,
  wrapperWs,
} from "../../../utils/analyzeUtils";

// Import Api's
import {
  deleteAlert,
  deleteWorksheet,
  readAlerts,
  updateAlert,
  updateWorksheetStatus,
} from "../../../services/api/index";

// Import Config
import { config } from "../../../config/config";

// Import Custom Components
import AnalyzeShareDialog from "../../Analyze/AnalyzeDashboard/AnalyzeShareDialog";
import WorkspaceCreateHelpers from "../../WorkSpace/WorkspaceHome.js/WorkspaceCreateHelpers";
import AlertsManager from "./AlertsManager";
import SigviewBreadcrumbs from "../../../components/Common/SigviewBreadcrumbs";

// Import Images
import deleteIcon from "../../../../assets/images/deleteIcon.svg";
import editIcon from "../../../../assets/images/editIcon.svg";
import NoAlert from "../../../../assets/images/NoAlert.svg";

// Import Styling
import { ThemeContext } from "../../../contexts/ThemeContext";
import LayoutTopSideBottom from "../../../layouts/LayoutTopSideBottom/LayoutTopSideBottom";
import SigviewTypography from "../../../components/Common/SigviewTypography";
import SigviewButton from "../../../components/Common/SigviewButton";
import {
  getDimensionObjFromId,
  getMetricObjByFromId,
  getMetricObjFromId,
  unWrapperFunc,
  unWrapperFuncSideNav,
  userSelection,
  wrapper,
} from "../../../utils/alertUtils";
import SigviewSwitch from "../../../components/Common/SigviewSwitch";
import useReducerLogger from "../../../utils/useReducerLogger";
import alertFormReducer from "../../../redux/reducers/alertForm";
import axios from "axios";
import Loader from "../../../components/Loader/Loader";
import ErrorHandler from "../../../components/ErrorHandler/ErrorHandler";
import SigviewSearchField from "../../../components/Common/SigviewSearchField";
import SigviewTooltip from "../../../components/Common/SigviewTooltip";

const defaultState = { ...userSelection };
const initialDataState = { status: "loading", message: "", result: [] };
const initialAlert = { status: "success", message: "", result: [] };

const AlertsTable = (props) => {
  const {
    dispatch: ReduxDispatcher,
    user = {},
    allData = {},
    globalFilters,
    initialState = defaultState,
  } = props;

  const [showAlertManager, setShowAlertManager] = useState(false);
  const [alerts, setAlerts] = useState(initialDataState);
  const [reloadData, setReloadData] = useState(false);
  const [activeAlertNav, setActiveAlertNav] = useState("details");
  const [alertListData, setAlertListData] = useState(initialAlert);
  const [tableData, setTableData] = useState(initialDataState);

  const { state: themeState } = useContext(ThemeContext);
  const themeColors = themeState.themes[themeState.activeTheme];
  const history = useHistory();
  const sidenavProps = { tabName: "alerts" };
  //making styles for all variations
  const useStyles = makeStyles(() => ({
    root: {
      backgroundColor: themeColors["workspacePrimaryColor"],
      borderBottom: "none",
    },
    tableHeader: {
      padding: "6px 16px",
      borderBottom: "none",
      fontWeight: "bold",
    },
    headerContainer: {
      display: "flex",
      justifyContent: "space-between",
      alignItems: "center",
      padding: "10px 25px",
    },
    headerSubContainer: {
      display: "flex",
      justifyContent: "flex-end",
      alignItems: "center",
      gap: "10px",
      width: "400px",
      minWidth: "250px",
    },
    mainContainer: {
      padding: "0px 25px 10px",
    },
  }));
  const classes = useStyles();

  initialState.dimensionFilters = {
    ...initialState.dimensionFilters,
    value: globalFilters.dimensionFilters,
  };
  initialState.timeZone = {
    ...initialState.timeFilters,
    value: globalFilters.timeFilters.selectedTimezone.name,
  };
  //initialState.dimensionFilters.value = globalFilters.dimensionFilters;
  const alertFormDataOriginal = useRef(initialState);
  // Alert list state for the selected id
  const [selectedAlertId, setSelectedAlertId] = useState(null);
  // Defining the main reducer
  const [state, dispatch] = useReducer(
    useReducerLogger(alertFormReducer),
    initialState
  );
  // To get the maxSavedAlerts
  const maxSavedAlerts = user.uiLimitsList.maxSavedAlerts;

  // * Defining requires variables
  // FUNC: For unWrapperData
  const unWrapperData = unWrapperFunc(alerts.result, allData, user);

  // console.groupCollapsed("AlertManager Check");
  // console.log("alertListData", alertListData);
  // console.log("unWrapperData", unWrapperData);
  // console.log("alerts", alerts);
  // console.groupEnd();

  // * Defining required event handlers
  // FUNC: For every actions
  const handleReloadAlerts = () => {
    setReloadData(!reloadData);
  };

  // Opening the selected alerts from sideNav to the alertForm
  const handleActive = (e, id) => {
    // Update state to show the alert form for the selected alert
    setSelectedAlertId(id);
    setShowAlertManager(true);
    // Updation of the state with new selected alert
    const selectedAlert = unWrapperData.find((elem) => elem.id.value === id);
    // reducer dispatch action with value
    const payload = { value: selectedAlert };
    const action = replaceAlertForm(payload);
    dispatch(action);
    alertFormDataOriginal.current = { ...selectedAlert };
  };

  // FUNC: For toggling every alert from sideNav
  const handleToggle = (e, id) => {
    // Google Analytics Event - Master
    masterTrackGaEvent({
      category: "AlertManager",
      action: "AlertStatus",
      label: "SideNav",
    });

    // Toggle the only one alert
    //! For the progressbar
    const updatedAlertListData = alertListData.result.map((el) => {
      if (el.id === id) {
        const elMod = {
          ...el,
          isActiveData: { message: "", status: "loading" },
        };
        return elMod;
      }
      return el;
    });
    setAlertListData({
      status: "success",
      message: "",
      result: updatedAlertListData,
    });
    let toggleAlert = unWrapperData.find((el) => el.id.value === id);
    toggleAlert = {
      ...toggleAlert,
      active: {
        ...toggleAlert.active,
        value: !toggleAlert.active.value,
      },
    };

    const payload = wrapper(
      { ...toggleAlert },
      user?.reqMetadata?.email,
      allData,
      globalFilters
    );
    const source = axios.CancelToken.source();
    const fetchProps = {
      cancelToken: source.token,
      payload,
    };

    const updateAlertPromise = updateAlert(fetchProps);
    updateAlertPromise
      .then((data) => {
        if (data.status.statusCode === "200") {
          const toggleAlert = alerts.result.map((el) => {
            if (el._id === id) {
              const elMod = {
                ...el,
                patternStatus:
                  el.patternStatus === "active" ? "inactive" : "active",
              };
              return elMod;
            }
            return el;
          });
          // console.log("alertListData toggle handleToggle", toggleAlert);
          const newData = {
            status: "success",
            message: "",
            result: toggleAlert,
          };
          setAlerts(newData);
          setTableData(newData);

          const updatedAlertListData = alertListData.result.map((el) => {
            if (el.id === id) {
              const elMod = {
                ...el,
                isActive: !el.isActive,
              };
              return elMod;
            }
            return el;
          });
          setAlertListData({
            status: "success",
            message: "",
            result: updatedAlertListData,
          });
        } else {
          // In case the api fails then we have to reload the alerts
          setReloadData(!reloadData);
        }
      })
      .catch((json) => {
        // In case the api fails then we have to reload the alerts
        setReloadData(!reloadData);
        console.groupCollapsed("API ERROR");
        console.error("ERROR -> ", json.error);
        console.groupEnd();
      });
  };

  // To add new alert from the Add New Alert button
  const handleAddNewAlert = (label) => {
    console.log("inside handleAddNewAlert...");
    // Google Analytics Event - Master
    masterTrackGaEvent({
      category: "AlertManager",
      action: "AddNewAlert",
      label,
    });

    // state of the opeaning the alertMangerForm
    setShowAlertManager(true);

    // reducer dispatch action with value
    // Replace the email with the current user
    const finalInitialState = {
      ...initialState,
      id: {
        ...initialState.id,
        value: Date.now().toString(),
      },
      emailRecipients: {
        ...initialState.emailRecipients,
        value: [
          {
            id: user?.reqMetadata?.email,
            name: user?.reqMetadata?.email,
            deletable: false,
          },
        ],
      },
    };

    let payload = { value: finalInitialState };
    let action = replaceAlertForm(payload);
    dispatch(action);

    const value = `Pattern ${alerts.result.length + 1}`;
    payload = { key: "name", value };
    action = updateAlertForm(payload);
    dispatch(action);

    // Opeaning the default deatils tab on opeaning the alertMangerForm
    setActiveAlertNav("details");
    // resetting the selected alert id
    setSelectedAlertId(null);

    // Update alert form original
    alertFormDataOriginal.current = { ...initialState };
  };

  // Delete event listener
  // Run on clicking  delete button
  const handleDelete = (id) => {
    // Google Analytics Event - Master
    masterTrackGaEvent({
      category: "AlertManager",
      action: "AlertCURD",
      label: "delete",
    });

    const message = {
      title: `Are you sure you want to delete?`,
      subtitle: "",
    };

    const handleNo = () => {
      //Close the dialog box
      ReduxDispatcher(
        updateDialogInfo({
          ...user.dialogInfo,
          open: false,
        })
      );
    };

    const handleYes = () => {
      //Close the dialog box
      ReduxDispatcher(
        updateDialogInfo({
          ...user.dialogInfo,
          open: false,
          message: { title: "", subtitle: "" },
        })
      );

      //Update snackbar
      let snackbarPayload = {
        ...user.screen.snackbar,
        open: true,
        message: "Requesting deleting Alert",
      };
      ReduxDispatcher(updateUserScreen("snackbar", snackbarPayload));

      // Alert id to be deleted
      const alert_id = id;
      const fetchProps = {
        alert_id,
      };

      const deleteSavedAlertPromise = deleteAlert(fetchProps);
      deleteSavedAlertPromise
        .then(() => {
          //Update snackbar
          let snackbarPayload = {
            ...user.screen.snackbar,
            open: true,
            message: "Alert deleted sucessfully",
          };
          ReduxDispatcher(updateUserScreen("snackbar", snackbarPayload));
          setShowAlertManager(false);
          setReloadData(!reloadData);
        })
        .catch((json) => {
          console.log("API FAILED", json);

          let snackbarPayload = {
            ...user.screen.snackbar,
            open: true,
            message: json.error || "Requesting deleting Alert",
          };
          ReduxDispatcher(updateUserScreen("snackbar", snackbarPayload));
        });
    };
    ReduxDispatcher(
      updateDialogInfo({
        ...user.dialogInfo,
        open: true,
        message,
        handleYes,
        handleNo,
      })
    );
  };

  const handleSearchFieldChange = (e, value) => {
    const sourceData = alerts.result;
    const filteredData = !value
      ? sourceData
      : sourceData.filter((row) =>
          row.patternName?.toLowerCase().includes(value.toLowerCase())
        );
    const newData = {
      status: "success",
      message: "",
      result: filteredData,
    };
    setTableData(newData);
  };

  const getDimObjXAxisFromId = (dimId) => {
    var dimObj = allData.plotlyDimensions.find((el) => el._id === dimId);
    if (dimObj === undefined || dimObj === null) {
      return null;
    } else {
      return dimObj._id;
    }
  };

  // * Defining Required Side Effects
  // API call to get all alerts
  useEffect(() => {
    //Make fetch call using axios
    const source = axios.CancelToken.source();
    const fetchProps = {
      cancelToken: source.token,
    };
    const readAlertsPromise = readAlerts(fetchProps);
    readAlertsPromise
      .then((responseData) => {
        if (responseData.status.statusCode === "200") {
          let reverseAlerts = [...responseData.result.data].reverse();

          const newData = {
            status: "success",
            message: "",
            result: reverseAlerts,
          };
          var dataRemovedFromGetDimList = reverseAlerts.filter(
            (row) =>
              row.expression.dimNodeList?.dimensionId !==
              getDimensionObjFromId(
                row.expression.dimNodeList?.dimensionId,
                row.alertType,
                allData
              )
          );
          var dataRemovedFromGetMtericList = dataRemovedFromGetDimList.filter(
            (row) =>
              row.expression.dimNodeList?.metricId !==
              getMetricObjFromId(
                row.expression.dimNodeList?.metricId,
                row.alertType,
                allData
              )
          );
          let yAxisList = [];
          dataRemovedFromGetMtericList.forEach((row) => {
            if (row.payload.requestParam.yAxis.length > 0) {
              row.payload.requestParam.yAxis.forEach((item) => {
                if (getMetricObjByFromId(item, allData) === null) {
                  yAxisList.push(row.patternName);
                }
              });
            }
          });
          var finaldataRemovedFromYaxis = dataRemovedFromGetMtericList.filter(
            (row) => row.patternName !== yAxisList[0]
          );

          let xAxisList = [];
          finaldataRemovedFromYaxis.forEach((row) => {
            if (row.payload.requestParam.xAxis.length > 0) {
              row.payload.requestParam.xAxis.forEach((item) => {
                if (getDimObjXAxisFromId(item) === null) {
                  xAxisList.push(row.patternName);
                }
              });
            }
          });
          var finaldataRemovedFromXaxis = finaldataRemovedFromYaxis.filter(
            (row) => row.patternName !== xAxisList[0]
          );

          let specialCalculationList = [];
          finaldataRemovedFromXaxis.forEach((row) => {
            if (row.payload.requestParam.specialCalculation.length > 0) {
              row.payload.requestParam.specialCalculation.forEach((item) => {
                if (getMetricObjByFromId(item, allData) === null) {
                  specialCalculationList.push(row.patternName);
                }
              });
            }
          });
          var finaldataRemovedFromSpecialCalculation =
            finaldataRemovedFromXaxis.filter(
              (row) => row.patternName !== specialCalculationList[0]
            );

          let approxCountDistinctList = [];
          finaldataRemovedFromSpecialCalculation.forEach((row) => {
            if (row.payload.requestParam.approxCountDistinct.length > 0) {
              row.payload.requestParam.approxCountDistinct.forEach((item) => {
                if (getMetricObjByFromId(item, allData) === null) {
                  approxCountDistinctList.push(row.patternName);
                }
              });
            }
          });
          var finaldataRemovedFromApproxCountDistinctList =
            finaldataRemovedFromSpecialCalculation.filter(
              (row) => row.patternName !== approxCountDistinctList[0]
            );

          reverseAlerts = finaldataRemovedFromApproxCountDistinctList;

          var sideNavUnWrappedData = unWrapperFuncSideNav(reverseAlerts);
          setAlertListData({
            status: "success",
            message: "",
            result: sideNavUnWrappedData.data,
          });
          setAlerts(newData);
          setTableData(newData);
        } else {
          const newData = {
            status: "error",
            message:
              responseData.status?.statusMessage ||
              config.hardCoded.uiErrorMessage,
            result: [],
          };
          setAlerts(newData);
          setTableData(newData);
        }
      })
      .catch((json) => {
        console.groupCollapsed("API ERROR");
        console.error("ERROR -> ", json);
        console.groupEnd();
        const newData = {
          status: "error",
          message: json.error || config.hardCoded.uiErrorMessage,
          result: [],
        };
        setAlerts(newData);
        setTableData(newData);
      });
    //Clean-up function to cancel all pending fetch calls
    return () => {
      //Cancel all previous fetch calls
      if (source) source.cancel();
      // Reset alerts to initial state
      setAlerts(initialDataState);
      setTableData(initialDataState);
    };
  }, [reloadData]); // To refresh the alertList to get all alerts

  //DEBUGGER
  // useEffect(() => {
  //   console.groupCollapsed("RENDERED | AlertManager.js");
  //   console.log("STATE->", state);
  //   console.log("showAlertManager->", showAlertManager);
  //   console.log("alerts->", alerts);
  //   console.log("alertListData", alertListData);
  //   console.groupEnd();
  //   console.log("rows: ", rows);
  // });

  const disableAddNewAlertButton =
    alerts.status === "loading" || alert.status === "error"
      ? true
      : alerts.result.length >= maxSavedAlerts
      ? true
      : false;

  const rows = tableData.result.map((alert) => ({
    id: alert._id,
    alertName: alert.patternName,
    createdBy: alert.loginInfo.providerID,
    modifiedOn: new Date(Number(alert.modifiedOn)).toLocaleDateString(), // Converts epoch to readable date
    validTill: alert.expirationInfo.timePeriod,
    isActive: alert.patternStatus === "active" ? true : false,
  }));

  return (
    <LayoutTopSideBottom sidenavProps={sidenavProps}>
      {showAlertManager ? (
        <AlertsManager
          state={state}
          reloadData={reloadData}
          setReloadData={setReloadData}
          alertFormDataOriginal={alertFormDataOriginal}
          activeAlertNan={activeAlertNav}
          setActiveAlertNav={setActiveAlertNav}
          showAlertManager={showAlertManager}
          setShowAlertManager={setShowAlertManager}
          setSelectedAlertId={setSelectedAlertId}
          alerts={alerts}
        />
      ) : (
        <>
          <Box className={classes.headerContainer}>
            <SigviewTypography variant="heading" style={{ fontSize: "20px" }}>
              Alerts
            </SigviewTypography>
            <Box className={classes.headerSubContainer}>
              <SigviewSearchField
                onChange={(e, value) => handleSearchFieldChange(e, value)}
                placeholder="Search"
                customStyle={{
                  wrapperBgColor: "#f8f9fd",
                  wrapperBorderHover: "#fff",
                  wrapperBorderFocus: "#fff",
                  wrapperBorderColor: "1px solid #fff",
                }}
              />
              <SigviewButton
                customClassName="AddNewAlert-GA"
                variant="containedPrimary"
                disabled={disableAddNewAlertButton}
                title="Add new Alert"
                iconProps={{
                  className: "material-icons-round",
                  iconName: "add",
                }}
                iconPosition="end"
                iconFlag={true}
                style={{
                  fontSize: "14px",
                  buttonHeight: "34px",
                  borderRadius: "999em",
                }}
                onClick={() => {
                  handleAddNewAlert("Form");
                }}
              />
            </Box>
          </Box>
          <Box className={classes.mainContainer}>
            <TableContainer component={Paper} elevation={0}>
              <Table>
                <TableHead>
                  <TableRow className={classes.root}>
                    <TableCell
                      sx={{
                        padding: "6px 16px",
                        borderBottom: "none",
                        fontSize: "0.85rem",
                        fontWeight: "bold",
                      }}
                    >
                      Alert Name
                    </TableCell>
                    <TableCell
                      sx={{
                        padding: "6px 16px",
                        borderBottom: "none",
                        fontWeight: "bold",
                        fontSize: "0.85rem",
                        textAlign: "center",
                      }}
                    >
                      Created By
                    </TableCell>
                    <TableCell
                      sx={{
                        padding: "6px 16px",
                        borderBottom: "none",
                        fontWeight: "bold",
                        fontSize: "0.85rem",
                        textAlign: "center",
                      }}
                    >
                      Modified On
                    </TableCell>
                    <TableCell
                      sx={{
                        padding: "6px 16px",
                        borderBottom: "none",
                        fontWeight: "bold",
                        fontSize: "0.85rem",
                        textAlign: "center",
                      }}
                    >
                      Valid Till
                    </TableCell>
                    <TableCell
                      sx={{
                        padding: "6px 16px",
                        borderBottom: "none",
                        fontWeight: "bold",
                        fontSize: "0.85rem",
                        textAlign: "center",
                      }}
                    >
                      Action
                    </TableCell>
                  </TableRow>
                </TableHead>

                <TableBody>
                  {alerts.status === "loading" && (
                    <TableRow>
                      <TableCell
                        colSpan={5}
                        align="center"
                        sx={{ borderBottom: "none" }}
                      >
                        <Loader />
                      </TableCell>
                    </TableRow>
                  )}
                  {alerts.status === "error" && (
                    <ErrorHandler
                      message={alerts.message}
                      reloadFlag={true}
                      handleReloadAlerts
                      onReload={handleReloadAlerts}
                    />
                  )}
                  {alerts.status === "success" &&
                    rows.length > 0 &&
                    rows.map((row) => (
                      <TableRow
                        key={row.id}
                        hover
                        onClick={(e) => {
                          handleActive(e, row.id);
                        }}
                        sx={{
                          cursor: "pointer",
                          "&:hover": {
                            backgroundColor: "#f5f5f5",
                          },
                          // Remove bottom border
                          borderBottom: "none",
                        }}
                      >
                        <TableCell
                          sx={{
                            maxWidth: 200,
                            overflow: "hidden",
                            whiteSpace: "nowrap",
                            textOverflow: "ellipsis",
                            fontSize: "0.8rem",
                            padding: "4px 16px",
                            borderBottom: "none",
                          }}
                          title={row.worksheetName}
                        >
                          {row.alertName}
                        </TableCell>
                        <TableCell
                          sx={{
                            padding: "4px 16px",
                            borderBottom: "none",
                            textAlign: "center",
                            fontSize: "0.8rem",
                          }}
                        >
                          {row.createdBy}
                        </TableCell>
                        <TableCell
                          sx={{
                            padding: "4px 16px",
                            borderBottom: "none",
                            textAlign: "center",
                            fontSize: "0.8rem",
                          }}
                        >
                          {row.modifiedOn}
                        </TableCell>
                        <TableCell
                          sx={{
                            padding: "4px 16px",
                            borderBottom: "none",
                            textAlign: "center",
                            fontSize: "0.8rem",
                          }}
                        >
                          {row.validTill}
                        </TableCell>
                        <TableCell
                          onClick={(e) => e.stopPropagation()}
                          sx={{
                            padding: "4px 16px",
                            borderBottom: "none",
                            display: "flex",
                            justifyContent: "center",
                            gap: 2,
                            my: 0.6,
                          }}
                        >
                          <SigviewTooltip
                            title={row.isActive ? "Deactivate" : "Activate"}
                          >
                            <Box>
                              <SigviewSwitch
                                id={row.id}
                                onChange={(e) => handleToggle(e, row.id)}
                                name="Sigview Switch"
                                checked={row.isActive}
                                customClassName="AlertON-OFF-GA"
                              />
                            </Box>
                          </SigviewTooltip>
                          <SigviewTooltip title="Edit">
                            <Box
                              onClick={(e) => {
                                e.stopPropagation();
                                handleActive(e, row.id);
                              }}
                              style={{
                                cursor: "pointer",
                                display: "flex",
                                justifyContent: "center",
                                alignItems: "center",
                              }}
                            >
                              <img src={editIcon} alt="Edit" />
                            </Box>
                          </SigviewTooltip>
                          <SigviewTooltip title="Delete">
                            <Box
                              onClick={(e) => {
                                e.stopPropagation();
                                handleDelete(row.id);
                              }}
                              style={{
                                cursor: "pointer",
                                display: "flex",
                                justifyContent: "center",
                                alignItems: "center",
                              }}
                            >
                              <img src={deleteIcon} alt="Delete" />
                            </Box>
                          </SigviewTooltip>
                        </TableCell>
                      </TableRow>
                    ))}
                  {alerts.status === "success" && rows.length === 0 && (
                    <TableRow>
                      <TableCell
                        colSpan={5}
                        align="center"
                        sx={{ borderBottom: "none" }}
                      >
                        <Box
                          display="flex"
                          flexDirection="column"
                          alignItems="center"
                          justifyContent="center"
                        >
                          <img
                            src={NoAlert}
                            alt="No records found"
                            style={{
                              width: "350px",
                              height: "auto",
                              marginBottom: "12px",
                              marginTop: "120px",
                            }}
                          />
                          <p
                            style={{
                              color: "#6c757d",
                              fontSize: "16px",
                              margin: 0,
                            }}
                          >
                            No Alert
                          </p>
                        </Box>
                      </TableCell>
                    </TableRow>
                  )}
                </TableBody>
              </Table>
            </TableContainer>
          </Box>
        </>
      )}
    </LayoutTopSideBottom>
  );
};
const mapStateToProps = (state) => ({
  user: state.user,
  allData: state.data,
  globalFilters: state.globalFilters,
});

export default connect(mapStateToProps)(AlertsTable);
